module.exports = __webpack_public_path__ + "static/media/team-icon2-over.1b56b048.svg";